// @flow
import React from 'react';
import {
  compose,
  withProps,
  setDisplayName,
} from 'recompose';
import reactCSS from 'reactcss';
import AdIcon from './AdIcon';
import PremiumIcon from './PremiumIcon';
import { FormattedMessage } from 'react-intl';
import Badge, { Kind as BadgeKind } from '@ux/badge';
import { headingXs } from '@ux/type-size';
import { getStyles } from '@ux/style-utils';
import { gu2px } from '@ux/theme-utils';
import * as r from 'ramda';
import { isTrue, allPass } from '../../../crosscutting/capra';

const stylesheet = ({
  theme,
}) => {
  const {
    typography,
    palette,
    spacing,
  } = theme;

  return {
    default: {
      root: {
      },
      fqdn: {
        ...headingXs(typography),
        color: palette.grey02,
        fontWeight: 600,
        wordBreak: 'break-word',
        verticalAlign: 'middle',
        display: 'inline',
        marginRight: gu2px(1, spacing),
      },
      offset: {
        display: 'inline-block',
        // so icons/stickers sit 1GU apart
        marginRight: -(gu2px(0.5, spacing)),
      },
    },
  };
};

const stylesheetToStyles = r.unary(reactCSS);

export const PureDomainName = ({
  styles,
  theme,
  domain,
  isPremium,
  isAd,
  isPromo,
  isMinSm,
  intlNamespace,
}) => (
  <div style={styles.root}>
    <span style={styles.fqdn}>{domain}</span>
    {r.when(
      allPass,
      () => (
        <span style={styles.offset}>
          <Badge
            kind={BadgeKind.HIGHLIGHT}
            theme={theme}
          >
            <FormattedMessage id={`dst.${intlNamespace}.sale`}/>
          </Badge>
        </span>
      )
    )([ isPromo, isMinSm ])}
    {r.when(
      isTrue,
      () => (
        <span style={styles.offset}>
          <PremiumIcon theme={theme}/>
        </span>
      )
    )(isPremium)}
    {r.when(
      isTrue,
      () => (
        <span style={styles.offset}>
          <AdIcon theme={theme}/>
        </span>
      )
    )(isAd)}
  </div>
);

export const enhance = compose(
  setDisplayName('DomainName'),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureDomainName);
